"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCarouselRootPadding = void 0;
var _getNavigationArrowWidth = require("./getNavigationArrowWidth");
const getCarouselRootPadding = ({
  navigation
}) => {
  if (!navigation?.showArrows || navigation.position !== 'outside' || navigation.arrowsMode?.type === 'compact') {
    return 0;
  }
  return `0 calc(${(0, _getNavigationArrowWidth.getNavigationArrowWidth)({
    size: navigation.size
  })}px + ${navigation.size === 'small' ? 15 : 0}px)`;
};
exports.getCarouselRootPadding = getCarouselRootPadding;
